import { createUseStyles } from '../../theme/theming';

const useSectionStyles = createUseStyles((theme) => ({
  section: {
    width: '100%',
    padding: ({ isMobile } = {}) =>
      isMobile
        ? `${theme.spacing.padding.regular}px ${theme.spacing.padding.small}px`
        : `${theme.spacing.padding.small}px ${theme.spacing.padding.medium}px`,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',

    '&, & *, & *:before, & *:after': {
      fontFamily: theme?.typography?.fontFamily,
      boxSizing: 'border-box'
    },
    '& h2,& h3': {
      marginTop: '0'
    }
  },
  sectionContainer: {
    margin: '0 auto',
    maxWidth: ({ containerWidth } = {}) => containerWidth
  },
  subTitleHeading: {
    marginBottom: '8px',
    fontSize: theme.typography.fontSize.subHead,
    color: theme?.colors?.black,
    alignItems: 'center',
    textAlign: 'center',
    wordBreak: 'break-word',
    letterSpacing: '3px',
    textTransform: 'uppercase'
  },
  heading: {
    marginBottom: theme.spacing.margin.tiny,
    fontSize: theme.typography.fontSize.h2,
    color: theme?.colors?.black,
    fontWeight: theme.typography.fontWeight.bold,
    textAlign: 'center',
    wordBreak: 'break-word'
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '1000px',
    margin: 'auto'
  },
  content: {
    display: 'flex',
    width: 'calc(100% - 200px)',
    alignItems: 'center',
    background: theme?.colors?.white,
    boxShadow: theme?.shadows?.primary,
    borderRadius: theme?.shape?.borderRadius?.regular,
    overflow: 'hidden',
    minHeight: 200,
    marginBottom: theme.spacing.margin.small,
    position: 'relative',

    '&:nth-child(2n)': {
      alignSelf: 'flex-end',

      '& $contentNumber': {
        right: '0'
      },
      '& $contentText': {
        marginRight: '170px'
      }
    },
    '&:nth-child(2n+1)': {
      alignSelf: 'flex-start',

      '& $contentNumber': {
        left: '0'
      },
      '& $contentText': {
        marginLeft: '170px'
      }
    }
  },

  contentNumber: {
    position: 'absolute',
    top: '0',
    fontWeight: '700',
    background: theme?.colors?.background3,
    fontSize: '72px',
    letterSpacing: '-3px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '48px',
    height: '100%',
    color: theme?.colors?.font4,
    wordBreak: 'break-word'
  },
  contentText: {
    padding: theme.spacing.padding.tiny
  },
  contentHeading: {
    fontStyle: 'normal',
    fontSize: theme.typography.fontSize.h5,
    fontWeight: theme.typography.fontWeight.bold,
    lineHeight: '32px',
    marginBottom: '8px',
    color: theme?.colors?.lightblack,
    wordBreak: 'break-word'
  },
  contentPara: {
    fontStyle: 'normal',
    fontSize: '16px',
    lineHeight: '26px',
    color: theme?.colors?.gray,
    wordBreak: 'break-word'
  },

  '@media screen and (max-width: 767px)': {
    contentContainer: {
      width: '100%',
      gap: '8px'
    },
    content: {
      display: 'flex',
      flexDirection: 'column',
      borderRadius: theme.shape.borderRadius.large,
      width: '100%',
      height: 'auto',

      '&:nth-child(2n)': {
        marginLeft: '0',
        '& $contentText': {
          marginRight: '0',
          alignSelf: 'flex-start'
          // padding: '0'
        }
      },
      '&:nth-child(2n+1)': {
        marginRight: '0',
        '& $contentText': {
          marginLeft: '0',
          alignSelf: 'flex-start'
          // padding: '0'
        }
      }
    },

    contentNumber: {
      width: '100%',
      padding: '24px',
      position: 'static'
    },
    contentPara: {
      fontSize: '14px',
      lineHeight: '22px'
    },
    contentHeading: {
      fontSize: '20px',
      lineHeight: '32px'
    }
  }
}));

export default useSectionStyles;
